import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BlogCard from '../../Components/Blogs/BlogCard';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import config from '../../config';
import './blogs.css';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/blogs`);
        const blogs = await response.json();
        setBlogs(blogs);
      } catch (error) {
        console.error('Error fetching blogs', error);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div className='box-shadow'>
      <SectionHeader name={'Blogs'} />
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
        {blogs.map(blog => (
          <Link 
            className='blog-card-zoom' key={blog.id} to={`/blog/${blog.id}`}
            style={{ display: 'flex' }}
          >
            <BlogCard
              id={blog.id}
              photo={`${blog.photo}-small.jpg`}
              category={blog.category}
              title={blog.title}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogList;